<template>
<div class="text-body-2">
    <div v-if="Object.keys(postgres).length > 1">

      <TablesStLower/>
      <SideMenuTabs/>
      <OnePOneVStLower v-show="this.activeTab === Enums.SIDE_TABS.ONE_PERSON || this.$store.getters.getDialogOpen"/>
      <DemographicsStLower v-show="this.activeTab === Enums.SIDE_TABS.DEMOGRAPHICS || this.$store.getters.getDialogOpen"/>
      <!-- <PopChangeStLower/> -->
    </div>
  </div>
</template>
<script>
import { Enums } from "../../../data/Config/Config";
import SideMenuTabs from "../../Menus/SideMenu/SideMenuTabs";
import OnePOneVStLower from "../SelectedDistricts/StateLegLower/OnePOneVStLower";
import DemographicsStLower from "../SelectedDistricts/StateLegLower/DemographicsStLower";
import TablesStLower from "../SelectedDistricts/StateLegLower/TablesStLower";
// import PopChangeStLower from "../SelectedDistricts/StateLegLower/PopChangeStLower";

export default {
  name: "SelectedStLowerDistrict",
  components: {
    SideMenuTabs,
    OnePOneVStLower,
    DemographicsStLower,
    TablesStLower,
    // PopChangeStLower,
  },
  computed: {
    propub: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.PROPUB] || {}
      );
    },
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
    activeTab: function () {
      return this.$store.getters.getSideTab;
    },
  },
  data: function () {
    return {
      Enums: Enums,
    };
  },
  watch: {},
  methods: {
    useSSL(_url) {
      if (!_url.includes("https")) {
        return _url.replace("http", "https");
      }
      return _url;
    },
  },
};
</script>
<style scoped>
.centertextblock {
  text-align: center;
  display: block;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.selected-district-data-item {
  padding: 10px;
}

/*LOCATION REPORT REPRESENTATIVE INFO*/
.representative {
  margin-top: 5px;
  margin-bottom: 25px;
}

.representative-name {
  font-size: 18px;
  color: #404040;
  margin-bottom: 5px;
}

.representative-photo {
  max-width: 100px;
  vertical-align: text-top;
}

ul.representative-info {
  color: #333333;
  margin-bottom: 6px;
}

ul.representative-info li {
  margin-bottom: 3px;
}

ul.representative-info li a {
  display: inline-block;
  /*margin-left:4px;*/
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
}

.representative-info-source {
  padding-left: 5px;
  display: inline-block;
}

.info-label {
  float: left;
  clear: both;
  margin-right: 8px;
}

.info-value {
  overflow: hidden;
}

.title {
  overflow: inherit;
  background: var(--powder-blue);
  color: var(--prussian-blue);
  font-weight: 500;
  text-align: center;
}

.districtpanel-subhead {
  margin-top: 10px;
  margin-bottom: 0px !important;
  font-size: 1.1rem !important;
  font-weight: 400;
  letter-spacing: 0.0125em !important;
  font-style: italic;
}
.v-divider {
  margin-top: 10px;
}
</style>